if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    jQuery(document).ready(function($) {
        if($('body').hasClass('home')) {
            $('.page-container').hide();
            setTimeout(function() {
                $('.page-container').show();
            },200);
        }
    });
}